import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonos } from '../../data/content';
export function Bonuses() {
  return <section className="py-24 relative bg-pistachio-50 border-y border-line" data-id="element-1" data-mp="1hig0xesdz6h1">
      <div className="container mx-auto px-4" data-id="element-2" data-mp="1clfuh2rmk1pe">
        <div className="text-center mb-16" data-id="element-3" data-mp="18k4dflmtgost">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-surface text-pistachio-700 mb-6 border border-line" data-id="element-4" data-mp="18l5q1ujhdjcn">
            <GiftIcon size={32} aria-hidden="true" data-id="element-5" data-mp="20b0fdr7c991b" />
          </div>
          <h2 className="text-3xl md:text-5xl font-display font-bold text-ink mb-4" data-id="element-6" data-mp="208ny7g9en2pb">
            <span aria-hidden="true" data-id="element-7" data-mp="1w7c5h1v8i1cw">🎁</span> LOS 6 BONOS ESTRATÉGICOS
          </h2>
          <div className="inline-block px-4 py-1.5 rounded-full bg-pistachio-200 text-pistachio-800 text-sm font-bold tracking-widest uppercase" data-id="element-8" data-mp="1r9anyldgia3j">
            SIEMPRE INCLUIDOS · SIN COSTO ADICIONAL
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto mb-16" data-id="element-9" data-mp="fx05b7sffuct">
          {bonos.map((bono, index) => <motion.article key={bono.num} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="relative p-8 rounded-2xl bg-surface border border-line overflow-hidden group" data-id="element-10" data-mp="1jshs34k9kq49" data-mpi={index}>
              <div className="absolute top-0 right-0 p-6 text-6xl font-display font-bold text-pistachio-100 select-none pointer-events-none group-hover:text-pistachio-200 transition-colors" aria-hidden="true" data-id="element-11" data-mp="w1ufi5zelcbd">
                {bono.num}
              </div>

              <div className="relative z-10" data-id="element-12" data-mp="r1ztafqkpawn">
                <h3 className="text-xl font-bold text-ink mb-1 flex items-start gap-2" data-id="element-13" data-mp="d41e584fhag3">
                  <span aria-hidden="true" data-id="element-14" data-mp="i3xkhe0lldyt">🎁</span> {bono.title}
                </h3>
                <p className="text-sm font-medium text-pistachio-700 mb-4" data-id="element-15" data-mp="2jsjzas90vzn5">
                  {bono.subtitle}
                </p>
                <p className="text-muted leading-relaxed text-sm mb-6" data-id="element-16" data-mp="2f1lgnm0kapgq">{bono.desc}</p>

                <div className="flex items-center gap-3 pt-4 border-t border-line" data-id="element-17" data-mp="2azqekfat481w">
                  <span className="text-muted/70 line-through font-medium" data-id="element-18" data-mp="261f3604v5phk">
                    {bono.price}
                  </span>
                  <span className="text-pistachio-700 font-bold" data-id="element-19" data-mp="32qeancxmin8p">→ GRATIS</span>
                </div>
              </div>
            </motion.article>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto text-center p-6 rounded-2xl bg-pistachio-200/60 border border-pistachio-300" data-id="element-20" data-mp="2tq8307olwhhg">
          <p className="text-xl md:text-2xl font-medium text-ink" data-id="element-21" data-mp="1dchnm4s1e6si">
            Valor total de los 6 bonos{' '}
            <span className="line-through text-muted/70 mx-2" data-id="element-22" data-mp="138t4ipjw4tgk">$52.000 ARS</span>{' '}
            <span className="text-pistachio-800 font-bold" data-id="element-23" data-mp="187nkzkudy5xi">
              → GRATIS con tu Mega Pack
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}